import "reflect-metadata";

import { registerLocaleData } from "@angular/common";
import localeEl from "@angular/common/locales/el";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

registerLocaleData(localeEl, "el");

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
);
